import {
  authenticatedFetch,
  resolvePeriverseApiBaseUrl,
} from '../shared';
import {
  LocationTypeResponseDto,
  LocationTypesResponseDtoSchema,
} from '@peritasai/types';

type BaseUrlResolver = () => string;

export class LocationTypeApiClient {
  constructor(
    private readonly resolveBaseUrl: BaseUrlResolver = resolvePeriverseApiBaseUrl
  ) {}

  async getLocationTypes(): Promise<LocationTypeResponseDto[]> {
    const baseUrl = this.resolveBaseUrl();
    const url = `${baseUrl}/location-types`;

    try {
      const response = await authenticatedFetch(url, {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return LocationTypesResponseDtoSchema.parse(await response.json());
    } catch (error) {
      console.error('Error fetching location types:', error);
      throw error;
    }
  }
}

export const locationTypeApiClient = new LocationTypeApiClient();
